// Filament options available when claiming a 3D-printed reward.
export const FILAMENT_COLORS = [
  {
    id: "bambu-abs-white",
    hex: "#f5f5f4",
    label: "Bamboo Lab ABS White",
    isLight: true,
  },
  {
    id: "bambu-pla-basic-blue",
    hex: "#2563eb",
    label: "Bamboo Lab PLA Basic Blue",
  },
  {
    id: "amazon-basic-bright-green",
    hex: "#22c55e",
    label: "Amazon Basic Bright Green",
  },
  {
    id: "amazon-basic-pink",
    hex: "#ec4899",
    label: "Amazon Basic Pink",
  },
  {
    id: "esun-pla-plus-pine-green",
    hex: "#166534",
    label: "ESun PLA+ Pine Green",
  },
  {
    id: "amazon-basic-black",
    hex: "#1f2937",
    label: "Amazon Basic Black",
  },
  {
    id: "bambu-petg-translucent-teal",
    hex: "#2dd4bf",
    label: "Bamboo Lab PETG Translucent Teal",
    isLight: true,
  },
  {
    id: "bambu-translucent-white",
    hex: "#f8fafc",
    label: "Bamboo Lab Translucent White",
    isLight: true,
  },
  {
    id: "rainbow",
    hex: "#ef4444",
    label: "Rainbow",
    isRainbow: true,
  },
];

export const FILAMENT_COLOR_BY_ID = FILAMENT_COLORS.reduce((map, color) => {
  map[color.id] = color;
  return map;
}, {});

export const getFilamentLabel = (colorId) =>
  FILAMENT_COLOR_BY_ID[colorId]?.label || colorId || "—";

export const getFilamentHex = (colorId) =>
  FILAMENT_COLOR_BY_ID[colorId]?.hex || colorId || "transparent";

export const isFilamentLight = (colorId) =>
  Boolean(FILAMENT_COLOR_BY_ID[colorId]?.isLight);

export const isFilamentRainbow = (colorId) =>
  Boolean(FILAMENT_COLOR_BY_ID[colorId]?.isRainbow);
